import { createSlice } from "@reduxjs/toolkit";
import {
  AllEnquiriesThunk,
  GetSingleEnquiryThunk,
  AddEnquiryThunk,
  UpdateEnquiryThunk,
  DeleteEnquiryThunk,
} from "./thunk";

const initialState = {
  enquiries: [],
  singleEnquiry: null,
  loading: false,
  error: null,
  successMessage: null,
};

const enquiriesSlice = createSlice({
  name: "enquiries",
  initialState,
  reducers: {
    clearEnquiriesState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- ALL ENQUIRIES --------------------
      .addCase(AllEnquiriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllEnquiriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.enquiries = action.payload?.data || [];
      })
      .addCase(AllEnquiriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- SINGLE ENQUIRY --------------------
      .addCase(GetSingleEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleEnquiryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleEnquiry = action.payload.data || null;
      })
      .addCase(GetSingleEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- ADD ENQUIRY --------------------
      .addCase(AddEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(AddEnquiryThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Enquiry added successfully!";
      })
      .addCase(AddEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- UPDATE ENQUIRY --------------------
      .addCase(UpdateEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(UpdateEnquiryThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Enquiry updated successfully!";
      })
      .addCase(UpdateEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // -------------------- DELETE ENQUIRY --------------------
      .addCase(DeleteEnquiryThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(DeleteEnquiryThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.enquiries = state.enquiries.filter(
          (item) => item.uuid !== action.payload.uuid
        );
        state.successMessage = "Enquiry deleted successfully!";
      })
      .addCase(DeleteEnquiryThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearEnquiriesState } = enquiriesSlice.actions;
export default enquiriesSlice.reducer;
